<template>
  <form
    ref="availabilityForm"
    class="columns has-placeholders"
    v-on:submit="validateBeforeSubmit"
  >
    <div
      :class="{
        column: true,
        'is-8-tablet': true,
        'is-8-desktop': isFaq,
        'is-offset-2-desktop': isFaq,
        'is-6-desktop': isUnavailable,
        'is-4-fullhd': isUnavailable
      }"
    >
      <fieldset>
        <div class="columns">
          <div class="column is-half">
            <label for="FNAME" class="input -spacing-static-c">
              <input
                name="FNAME"
                id="FNAME"
                v-model="firstName"
                type="text"
                v-validate="'required|alpha'"
                maxlength="63"
                :class="{
                  input__field: true,
                  error: errors.has('FNAME')
                }"
                placeholder="First Name *"
              />
              <span class="input__label">First Name *</span>
            </label>
          </div>

          <div class="column is-half">
            <label for="LNAME" class="input -spacing-static-c">
              <input
                :class="{
                  input__field: true,
                  error: errors.has('LNAME')
                }"
                id="LNAME"
                name="LNAME"
                v-model="lastName"
                type="text"
                v-validate="'required|alpha'"
                maxlength="63"
                placeholder="Last Name *"
              />
              <span class="input__label">Last Name *</span>
            </label>
          </div>
        </div>

        <div class="columns">
          <div class="column padd-bottom-0">
            <label for="EMAIL" class="input -spacing-static-c">
              <input
                :class="{
                  input__field: true,
                  error: errors.has('EMAIL')
                }"
                name="EMAIL"
                id="emailAddress"
                v-model="emailAddress"
                type="email"
                v-validate="'required|email'"
                placeholder="Email Address *"
              />
              <span class="input__label">Email Address *</span>
            </label>
          </div>
        </div>

        <div class="columns">
          <div class="column padd-bottom-0 padd-top-0">
            <div class="select-wrapper -spacing-static-d">
              <v-select
                v-model="state"
                :searchable="true"
                maxHeight="13rem"
                :options="states"
                v-validate="'required'"
                placeholder="State*"
                name="MMERGE4"
                :class="{
                  error: errors.has('MMERGE4')
                }"
              ></v-select>
            </div>
          </div>
        </div>
      </fieldset>

      <div class="columns">
        <div class="column is-half-desktop padd-bottom-0 padd-top-0">
          <p class="-spacing-static-f">* Mandatory fields</p>
        </div>

        <div
          class="column is-half-desktop is-clearfix  padd-bottom-0 padd-top-0"
        >
          <button
            type="submit"
            class="button-primary button-primary--black -spacing-static-f is-pulled-right"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">Send</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'AvailabilityForm',
  props: ['isFaq', 'isUnavailable', 'queryState', 'floodlight'],
  data() {
    return {
      firstName: '',
      lastName: '',
      emailAddress: '',
      states: [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington D.C.',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
      ],
      state: ''
    };
  },
  mounted() {
    if (this.queryState) {
      if (this.states.indexOf(this.queryState) > -1) {
        this.state = this.queryState;
      }
    }
  },
  methods: {
    ...mapActions(['subscribeFormSubmit']),
    ...mapMutations(['toggleLoader']),
    validateBeforeSubmit(event) {
      if (this.floodlight) {
        this.$emit('floodlight');
      }
      event.preventDefault();
      let firstErrorField;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitForm();
          return;
        }
        firstErrorField = this.$el.querySelector(
          '[name="' + this.$validator.errors.items[0].field + '"]'
        );
        firstErrorField.focus();
      });
    },
    clearFormData() {
      setTimeout(() => {
        this.errors.clear();
      }, 5);
      this.firstName = '';
      this.lastName = '';
      this.emailAddress = '';
      this.state = '';
    },
    submitForm() {
      this.toggleLoader({
        loaderText: 'Loading...'
      });
      this.subscribeFormSubmit({
        userFirstName: this.firstName,
        userLastName: this.lastName,
        userEmailAddress: this.emailAddress,
        userState: this.state
      })
        .then(() => {
          this.toggleLoader();
          this.$snackbar.open({
            type: 'is-success',
            message: `Thank you for connecting with Porsche Auto Insurance!`,
            position: 'is-bottom',
            duration: 10000
          });
        })
        .catch(err => {
          this.toggleLoader();
          let message =
            err.msg || 'Something went wrong. Please try again later.';
          let toastType = 'is-danger';
          if (message && message.indexOf('already subscribed') >= 0) {
            message = "You're already subscribed. Thank you!";
            toastType = 'is-info';
          }
          this.$snackbar.open({
            type: toastType,
            message: message,
            position: 'is-bottom'
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.column {
  .column {
    &.padd-bottom-0 {
      padding-bottom: 0;
    }
    &.padd-top-0 {
      padding-top: 0;
    }
  }
}

form {
  margin-bottom: 2em !important;
}
</style>
